import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { FIELD_HISTORY_TYPE } from '../../../constants';
var normalizeFieldForHistory = function normalizeFieldForHistory(fieldId, fieldChanges, fieldMetadata) {
  // Can't type Object.keys in a better way
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  return Object.keys(fieldChanges).reduce(function (acc, property) {
    var normalizedKey = "".concat(fieldId, "|").concat(property);
    acc[normalizedKey] = {
      fieldId: fieldId,
      fieldType: fieldMetadata.fieldType,
      property: property,
      type: FIELD_HISTORY_TYPE
    };
    return acc;
  }, {});
};
export var normalizeFieldsAppliedChangesForHistory = function normalizeFieldsAppliedChangesForHistory(_ref) {
  var fieldsChanges = _ref.fieldsChanges,
    internalFormMetadata = _ref.internalFormMetadata;
  return Object.entries(fieldsChanges).reduce(function (acc, _ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
      fieldId = _ref3[0],
      fieldChanges = _ref3[1];
    var fieldMetadata = internalFormMetadata[fieldId];
    if (!fieldMetadata) {
      return acc;
    }
    var normalizedFieldHistory = normalizeFieldForHistory(fieldId, fieldChanges, fieldMetadata);
    Object.assign(acc, normalizedFieldHistory);
    return acc;
  }, {});
};